import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { FooterComponent } from '@rd/core/components/footer/footer.component';
import { UrlUtilsService } from '@rd/core/services/url-utils/url-utils.service';
import { BRAND_NAME } from '@rd/core/tokens/rd-lib.token';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'rd-westpac-footer',
  templateUrl: `./footer.component.html`,
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WestpacFooterComponent
  extends FooterComponent
  implements OnInit, OnDestroy
{
  @HostBinding('class.rd-westpac-footer') componentClass = true;

  destroy$ = new Subject();

  footerLogoAltText: string;
  footerLogoImageUrl: string;
  privacyPolicyUrl: URL;
  tncsUrl: URL;

  constructor(
    @Inject(BRAND_NAME) protected brandName: string,
    protected urlUtilService: UrlUtilsService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
  ) {
    super(brandName, urlUtilService);

    // Set footer image attributes
    this.footerLogoImageUrl = this.urlUtilsService.imageUrl(
      '/images/footer-logo.png',
    );
    this.footerLogoAltText = `${this.brandName} logo`;

    // Set footer link URLs
    this.tncsUrl = this.urlUtilsService.tncsUrl();
    this.privacyPolicyUrl = this.urlUtilsService.privacyPolicyUrl();
  }

  ngOnInit(): void {
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.cdRef.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  faqsUrl(): URL {
    return this.urlUtilsService.travelEdgeUrl('/company/faqs');
  }

  contactUsUrl(): URL {
    return this.urlUtilsService.travelEdgeUrl('/company/contact_us');
  }

  adminInfoTextParams(): { brandName: string } {
    return {
      brandName: this.brandName,
    };
  }

  shouldHideFooter(): boolean {
    const ROUTE_URLS = ['/offers'];
    const routeUrlWithoutParameter = this.router.url.split('?')[0];
    const hiddenRoute = !!ROUTE_URLS.find(
      (url) => url === routeUrlWithoutParameter,
    );

    return hiddenRoute;
  }
}
